<template>
    <div class="d-flex flex-nowrap align-center justify-center">
        <v-text-field v-model="dateDisplay" :label="label" @input="onInput" :required="required" :rules="rules" @click="edit" readonly :dense="dense" :disabled="disabled" />

        <v-dialog v-model="dialog" max-width="500px" :key="refreshKey">
            <v-form ref="editForm" @submit="onSave" @submit.prevent>
                <v-card>
                    <v-card-title>
                        <span class="headline">Edit Date</span>
                    </v-card-title>

                    <v-card-text>
                        <v-text-field v-model="editDate" max="9999-12-31" :label="label + ' (Date)'" type="date" :required="required" :rules="rules" />
                        <v-text-field v-model="editTime" :label="label + ' (Time)'" type="time" />
                        <v-text-field v-model="editOffset" :label="'UTC Offset'" type="text" :required="required" :rules="offsetRules" />
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="quinary" text @click="clear" :disabled="readonly">Clear</v-btn>
                        <div class="flex-grow-1"></div>
                        <v-btn color="quaternary" text @click="dialog = false">Cancel</v-btn>
                        <v-btn type="submit" color="quaternary" text :disabled="readonly">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    import { DateTime } from 'luxon'
    import dateUtility from '../services/dateUtility'

    // Consider the following represents a full date with timezone:
    // 2019-09-28T18:00:00+08:00

    export default {
        props: [
            'label',
            'value',
            'required',
            'rules',
            'hideOffset',
            'readonly',
            'dense',
            'disabled',
            'hasDefaultDate'
        ],

        data() {
            return {
                dateDisplay: null,
                date: null,
                time: null,
                offset: null,
                editDate: null,
                editTime: null,
                editOffset: null,
                valid: true,
                dialog: false,
                refreshKey: 0,
                offsetRules: [
                    v => {
                        return (!this.required || dateUtility.tryParseOffset(v).isValid) ? true : "Invalid offset";
                    }
                ]
            };
        },

        methods: {
            onInput() {
                var hasDate = typeof (this.date) !== "undefined" && this.date !== null && this.date !== "";
                var hasTime = typeof (this.time) !== "undefined" && this.time !== null && this.time !== "";
                var parseOffsetResult = dateUtility.tryParseOffset(this.offset);
                if (hasDate && parseOffsetResult.isValid) {
                    var offset = dateUtility.toIsoOffset(parseOffsetResult.offset);
                    var time = hasTime ? this.time : "00:00";
                    var output = this.date + 'T' + time + ':00' + offset;
                    this.dateDisplay = dateUtility.formatDateTime(output);
                    this.$emit('input', output);
                    this.valid = true;
                }
                else {
                    this.valid = !this.required;
                }
            },
            onSave() {
                this.date = this.editDate;
                this.time = this.editTime;
                this.offset = this.editOffset;
                this.onInput();
                this.dialog = false;
            },
            edit() {
                if (this.readonly) { return; }
                this.editDate = this.date;
                this.editTime = this.time;
                if (this.editTime === null) {
                    this.editTime = "00:00";
                }
                this.editOffset = this.offset;
                this.refreshKey++;
                this.dialog = true;
            },
            clear() {
                this.dialog = false;
                this.$emit('input', null);
            },
        },

        watch: {
            value: {
                immediate: true,
                handler(value) {
                    if (typeof value === 'undefined' || value === null) {
                        if (this.hasDefaultDate) {
                            var currentDate = DateTime.local();
                            this.date = currentDate.toISODate();
                            this.time = currentDate.set({ milliseconds: 0, seconds: 0 }).toISOTime({ suppressMilliseconds: true, suppressSeconds: true, includeOffset: false });
                            this.offset = dateUtility.toIsoOffset(DateTime.local().offset);
                            this.onInput();
                        }
                        else {
                            this.date = null;
                            this.time = null;
                            this.offset = dateUtility.toIsoOffset(DateTime.local().offset);
                            this.dateDisplay = '';
                        }
                    }
                    else {
                        var dateTime = DateTime.fromISO(value, { setZone: true });
                        this.date = dateTime.toISODate();
                        this.time = dateTime.toFormat("HH:mm");
                        this.offset = dateUtility.toIsoOffset(dateTime.offset);
                        this.dateDisplay = dateUtility.formatDateTime(value);
                    }
                    if (typeof this.offset === 'undefined' || this.offset === null) {
                        this.offset = dateUtility.toIsoOffset(DateTime.local().offset);
                    }
                }
            }
        }
    };
</script>
